import { useState } from 'react';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import PropertyHero from './components/PropertyHero';
import { GalleryGrid, GalleryLightbox } from './components/PropertyGallery';
import PropertyMatterport from './components/PropertyMatterport';
import PropertyStory from './components/PropertyStory';
import SignatureFeatures from './components/SignatureFeatures';
import EssentialInfo from './components/EssentialInfo';
import PropertyConcierge from './components/PropertyConcierge';
import PropertyReviews from './components/PropertyReviews';
import StickyBookBar from './components/StickyBookBar';
import OwnerRezWidgets from './components/OwnerRezWidgets';
import { ownerRezWidgetsForProperty } from '@/mocks/ownerRezWidgets';
import {
  heroData,
  galleryImages,
  storyData,
  signatureFeatures,
  essentialInfoGroups,
  reviews,
  conciergeConfig,
  stickyBarData,
} from './data/bella-vita';

export default function BellaVitaPage() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const ownerRezWidgets = ownerRezWidgetsForProperty(heroData.id);
  const reviewsWidget = ownerRezWidgets.find((widget) => widget.kind === 'reviews');

  const openLightbox = (index: number) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <main className="bg-background-50 text-foreground-900 font-body">
      <Header />
      <PropertyHero data={heroData} onViewPhotos={() => openLightbox(0)} />
      <GalleryGrid images={galleryImages} propertyName={heroData.name} onRequestOpen={openLightbox} />
      <PropertyMatterport propertyName={heroData.name} src={heroData.matterportUrl} />
      <EssentialInfo
        groups={essentialInfoGroups}
      />
      <PropertyStory data={storyData} propertyName={heroData.name} />
      <SignatureFeatures features={signatureFeatures} />
      <OwnerRezWidgets propertyName={heroData.name} widgets={ownerRezWidgets} />
      <PropertyReviews reviews={reviews} propertyName={heroData.name} ownerRezWidget={reviewsWidget} />
      <PropertyConcierge config={conciergeConfig} />
      <Footer />
      <StickyBookBar data={stickyBarData} />
      <GalleryLightbox
        images={galleryImages}
        isOpen={lightboxOpen}
        initialIndex={lightboxIndex}
        onClose={() => setLightboxOpen(false)}
      />
    </main>
  );
}
